import React from "react";

import withTranslations from "../../../../../hocs/withTranslations";

function AuthOrDivider({ translate }) {
  return (
    <div className={"flex flex-row gap-4 align-center mt-6 mb-6"}>
      <div className={"flex-1 border-black-1 border-bottom"} />
      <span
        className={
          "uppercase line-height-160 text-xs.1 font-medium text-black opacity-35"
        }
      >
        {translate("auth_or-divider_text")}
      </span>
      <div className={"flex-1 border-black-1 border-bottom"} />
    </div>
  );
}

export default withTranslations(AuthOrDivider);
